export function convertToBase64(file) {
    return new Promise((resolve, reject) => {
        try {
            const reader = new FileReader();

            let base64String;
            reader.onload = function () {
                base64String = reader.result;

                resolve(base64String)
            }
            reader.readAsDataURL(file);
        } catch (error) {
            reject(error);
        }
    })
}
